<template>
  <!-- 订单状态信息 -->
  <div class="order_status_con text_left">
    <div
      v-if="subOrderStatusTitle"
      class="font16 font_weight600 colo087 order_title"
    >
      {{ subOrderStatusTitle }}
    </div>
    <div v-if="statusConstant" class="font12 font_weight400 colo055">
      {{ statusConstant }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statusConstant: {
      type: String,
      default: ""
    },
    subOrderStatusTitle: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.order_status_con {
  background: #fff;
  padding: 12px 16px 16px;
  .order_title {
    padding-bottom: 6px;
    font-size: 16px;
    line-height: 22px;
  }
}
</style>
